// ─────────────────────────────────────────────────────────────────────
// Shipping engine — สูตรเดียว ใช้ทั้ง client (estimate) และ Worker (ทางการ)
// กติกาจาก docs/03-SHIPPING.md (ห้ามเพี้ยน):
//   chargeable_g = Σ(weight_g × qty) + pack_material_grams   (+150g internal)
//   postage      = lookupRate(zone, chargeable_g, method)
//   ship_cost    = postage + pack_handling_fee               (+10฿ internal)
// ลูกค้าเห็นแค่ total ก้อนเดียว — ไม่คืน breakdown postage/pack
// rows รูปแบบเดียวกับ store.shipping_rate (band + overflow step)
// ─────────────────────────────────────────────────────────────────────

export function chargeableGrams(items, packMaterialGrams) {
  return items.reduce((s, i) => s + (i.weight_g || 0) * (i.qty || 0), 0) + packMaterialGrams;
}

// rates = array ของ rate rows (จาก DB หรือ seed) · คืน [{key,label,eta,total}] เรียงถูก→แพง
export function quote(zone, chargeableG, rates, caps, packHandlingFee) {
  const zoneRates = rates.filter((r) => r.zone_code === zone);
  const methods = [...new Set(zoneRates.map((r) => r.method))];
  const capG = zone === 'dom' ? caps.dom_max_g : caps.intl_max_g;
  const g = Math.min(chargeableG, capG); // เกินเพดาน → คิดที่เพดาน ไม่ error

  const out = [];
  for (const method of methods) {
    const rows = zoneRates.filter((r) => r.method === method);
    const bands = rows.filter((r) => !r.is_overflow).sort((a, b) => a.max_g - b.max_g);
    const of = rows.find((r) => r.is_overflow);
    if (!bands.length) continue;

    let postage;
    const band = bands.find((b) => g <= b.max_g);
    if (band) postage = Number(band.price_thb);
    else if (of) {
      const last = bands[bands.length - 1];
      postage = Number(last.price_thb) + Math.ceil((g - last.max_g) / of.step_g) * Number(of.price_thb);
    } else postage = Number(bands[bands.length - 1].price_thb);

    out.push({
      key: method,
      label: rows[0].method_label,
      eta: rows[0].eta || '',
      // pack fee รวมเงียบๆ · ปัดขึ้นให้ลงท้าย 0/5 (ตัวเลขสวยสำหรับลูกค้า)
      total: Math.ceil((postage + packHandlingFee) / 5) * 5,
    });
  }
  return out.sort((a, b) => a.total - b.total);
}

// ส่งฟรี: เฉพาะในประเทศ + subtotal ≥ threshold (intl ไม่ฟรี)
export function freeShipEligible(zone, subtotal, threshold) {
  return zone === 'dom' && threshold > 0 && subtotal >= threshold;
}
